<!-- Spinner -->

<!-- Content -->
@if ((slideViewerFacade.allCurrentSelectedSlideCopyrights$ | async); as copyrights) {
  <footer class="sidebar-copyrights">
    @for (copyright of copyrights; track copyright) {
      <span class="sidebar-copyright">
        {{ copyright.copyright.text }} {{ copyright.text }}
      </span>
    }
  </footer>
} @else {
  <div class="d-flex justify-content-center m-2">
    <div class="spinner-border"></div>
  </div>
}
